// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1_7j3","col":"styles_col__2Rqs3"};